export const useMyTeamsHeaderTitle = (
  route: any,
  reduxActiveTab: string,
  tt: any,
) => {
  if (route?.params?.title) return route.params.title;

  return reduxActiveTab === 'my-teams'
    ? tt('myTeams', 'My Teams')
    : tt('watchlist', 'Watchlist');
};
